<script setup lang="ts">
import { mockNewsItems } from "~/assets/ts/announcementItems";

useSeoMeta({
	title: "お知らせ一覧｜株式会社Bang",
	description: "株式会社Bangのお知らせ一覧を掲載しています。",

	ogTitle: "お知らせ一覧｜株式会社Bang",
	ogDescription: "株式会社Bangのお知らせ一覧を掲載しています。",
	ogUrl: "https://www.bang-inc.jp/info",
});

const navItems = [
	{ text: "トップページ", href: "/" },
	{ text: "お知らせ一覧" },
];
</script>
<template>
    <main class="info">
        <!-- パンくずリスト -->
        <Breadcrumbs :items="navItems" />
        <div class="info-body">
            <HeadingCorp :level="1">お知らせ一覧</HeadingCorp>
            <!-- NewsContainerコンポーネントを使用 -->
            <AnnouncementContainer :items="mockNewsItems" />
        </div>
    </main>
</template>

<style scoped lang="scss">
.info {
    position: relative;
    width: min(91vw, 64.5rem);
    margin: auto;

    &::before {
        content: '';
        position: absolute;
        width: 20rem; // 320px
        height: 20rem; // 320px
        aspect-ratio: 1/1;
        left: -4rem; // -64px
        top: -3rem; // -48px
        border-radius: 20rem; // 320px
        box-sizing: border-box;
        border: 1.5rem solid #EFF7FF; // 24px
        z-index: -1; // コンテンツの背景に配置
        pointer-events: none; // クリックイベントを通す
    }

    &-body {
        padding: 2rem 0 8rem 0;
    }
}

.news {
    margin: auto;
}

// PC用のスタイル
@include mixin.media(pc) {
    .info {
        &::before {
            width: 32.5rem; // 520px
            height: 32.5rem; // 520px
            left: -10.7rem; // -171.2px
            top: -4rem; // -64px
            border-radius: 32.5rem; // 520px
            border: 2.5rem solid #EFF7FF; // 24px
        }

        &-body {
            padding: 3.5rem 0 8rem 0;
        }
    }

    .news {
        border-top: 0.0625rem solid #E5E5E7;
        padding: 1rem 0;
    }
}
</style>